import { FC } from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { TrashIcon } from "@radix-ui/react-icons";
import { cn } from "@/utils/tailwind/utils";
import { DataSchema } from "common";
import { useTranslation } from "react-i18next";

type ChatHistoryMenuProps = {
  selectedId: string;
  open: boolean;
  setOpen: (open: boolean) => void;
  histories: DataSchema.ChatMetadata[];
  onClickMenuItem: (id: string) => void;
  onClickTrash: (data: DataSchema.ChatMetadata) => void;
};

export const ChatHistory: FC<ChatHistoryMenuProps> = (props) => {
  const { selectedId, open, setOpen, histories, onClickMenuItem, onClickTrash } = props;
  const { t } = useTranslation();

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger className="size-0" />

      <DropdownMenuContent
        className="w-[344px] max-w-[100vw] p-0 pt-2 sm:w-[344px] sm:max-w-[344px]"
        align="start"
        side="top"
      >
        <DropdownMenuLabel className="mx-2 text-sm font-medium text-gray-500">{t("chat_history")}</DropdownMenuLabel>

        <div className="max-h-[calc(100svh-180px)] overflow-y-auto overflow-x-hidden pb-2 sm:max-h-[calc(100svh-220px)]">
          {histories.length === 0 && (
            <div className="px-4 pb-2 pt-1">
              <p className="text-sm">{t("chat_history_empty")}</p>
            </div>
          )}
          {histories.map((data, index) => {
            const selected = selectedId === data.id;
            const selectedBg = selected ? "bg-gray-300" : "";
            return (
              <DropdownMenuItem
                key={index}
                className={cn("mx-2 flex h-8 max-h-8 flex-row gap-x-2 pr-0 data-[disabled]:opacity-100", selectedBg)}
                disabled={selected}
                onClick={(e) => {
                  e.preventDefault();
                  if (!selected) {
                    onClickMenuItem(data.id);
                  }
                }}
              >
                <p className="max-h-5 max-w-[278px] flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-sm">
                  {data.title}
                </p>

                <div className="min-h-8 min-w-8">
                  {!selected && (
                    <Button
                      variant="ghost"
                      className="h-8 w-8 p-0"
                      disabled={selected}
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        onClickTrash(data);
                      }}
                    >
                      <TrashIcon className="h-4 w-4" />
                    </Button>
                  )}
                </div>
              </DropdownMenuItem>
            );
          })}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
